import React from "react";
import { useIntl } from "react-intl";
import moment from "moment-timezone";
import { makeStyles } from "tss-react/mui";
import "../../input/validation.js";
import "../../input/DatePicker.js";
import { DateRangePicker } from "../../input/DateRangePicker.js";
import "../../input/StyledInput.js";
import "../../input/FormInput.js";
import "../../input/StyledFormInputHoc.js";
import "../../input/DateSinglePicker.localize.js";
import "../../input/hooks.js";
import "@mui/material";
import { useDateRangeFilter } from "./hooks.js";
import { localized } from "./localized.js";
const useStyles = makeStyles()({
  dateRangeFilter: {
    width: 350
  }
});
function DateRangeFilter({
  value,
  onChange,
  rangeMode = "default",
  locale,
  availableDateRangeForSelection,
  width = "fixed",
  placeholder,
  footer,
  errorMessage,
  onSelect,
  hint,
  defaultVisibleMonth = "to",
  filterEntity,
  hasInputTooltip
}) {
  const { classes, cx } = useStyles();
  const { formatMessage } = useIntl();
  const {
    value: dateRangeValue,
    handleChange,
    handleSelect,
    availableRangeForSelection: availableRangeForSelectionInternal
  } = useDateRangeFilter({ value, onChange }, availableDateRangeForSelection, onSelect);
  function getInputTooltipMessage() {
    let rangeValue = "";
    if (availableRangeForSelectionInternal?.from) {
      const diffInMs = moment().diff(moment(availableRangeForSelectionInternal.from));
      rangeValue = moment.duration(diffInMs).humanize();
    }
    const inputTooltipMessageMap = {
      report: formatMessage(localized.reportInputTooltipMessage, { range: rangeValue })
    };
    return !value?.from && hasInputTooltip ? inputTooltipMessageMap[filterEntity] : null;
  }
  const selectedMonth = {
    from: dateRangeValue?.from,
    to: dateRangeValue?.to
  };
  return /* @__PURE__ */ React.createElement(
    DateRangePicker,
    {
      value: dateRangeValue,
      onChange: handleChange,
      onSelect: handleSelect,
      disableFutureDates: true,
      rangeMode,
      locale,
      pickerClassName: cx(width === "fixed" && classes.dateRangeFilter),
      hasBottomSpacing: false,
      placeholder: placeholder ?? localized.placeholder,
      availableDateRangeForSelection: availableRangeForSelectionInternal,
      selectedMonth: selectedMonth[defaultVisibleMonth],
      footer,
      hint,
      errorMessage,
      inputTooltipMessage: getInputTooltipMessage()
    }
  );
}
export {
  DateRangeFilter
};
//# sourceMappingURL=DateRangeFilter.js.map
